import { trustStats, trustPoints } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function TrustStats() {
  return (
    <section className="bg-accent-50 border-y border-accent-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="透明度与信任"
              icon="ri-shield-check-line"
              title="先把话说清楚，再谈怎么看"
              desc="页面的作用是把黑料网5特色与区别讲明白。结构、维度、板块划分都公开在页面上，不靠话术引导，也不隐藏判断依据。"
            />

            <div className="mt-8 flex flex-col gap-4">
              {trustPoints.map((point) => (
                <div
                  key={point.title}
                  className="flex items-start gap-4 rounded-lg border border-accent-100 bg-background-50 p-4"
                >
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${point.icon} text-[18px]`}></i>
                  </span>
                  <div className="flex flex-col">
                    <span className="font-heading text-sm font-semibold text-foreground-950">
                      {point.title}
                    </span>
                    <p className="mt-1 font-body text-sm leading-relaxed text-foreground-600">
                      {point.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {trustStats.map((stat, index) => (
                <div
                  key={stat.label}
                  className={`rounded-lg border p-6 flex flex-col justify-between min-h-[160px] ${
                    index === 0
                      ? "bg-primary-500 border-primary-500"
                      : "bg-background-50 border-accent-100"
                  }`}
                >
                  <span
                    className={`w-9 h-9 flex items-center justify-center rounded-md ${
                      index === 0
                        ? "bg-foreground-950/15 text-foreground-950"
                        : "bg-accent-100 text-accent-700"
                    }`}
                  >
                    <i className="ri-bar-chart-2-line text-[17px]"></i>
                  </span>
                  <div className="mt-6">
                    <span className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                      {stat.value}
                    </span>
                    <p
                      className={`mt-2 font-body text-sm leading-relaxed ${
                        index === 0 ? "text-foreground-900" : "text-foreground-600"
                      }`}
                    >
                      {stat.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}